module.exports = __webpack_public_path__ + "media/assets/images/Card_2-97628a78ea201ef1b01c72a257d78b03.png";